import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "line-awesome/dist/line-awesome/css/line-awesome.css";
import "rsuite/dist/rsuite.min.css";
import Routers from "./routes";
import store, { persistor } from "./store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { BrowserRouter as Router } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { i18n } from "./utils";
import { NotificationProvider } from "./utils/notification";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <PersistGate persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        <NotificationProvider>
          <Router>
            <Routers />
          </Router>
        </NotificationProvider>
      </I18nextProvider>
    </PersistGate>
  </Provider>
);
